var moduleMap = {
	"./diContainer": () => {
		return Promise.all(/* diContainer */[__webpack_require__.e("src_service-setup_diContainer_tsx"), __webpack_require__.e("diContainer")]).then(() => (() => ((__webpack_require__("./src/service-setup/diContainer.tsx")))));
	},
	"./content-block": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/content-block/index.ts")))));
	},
	"./elc-basic-tout-v1": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/basic-tout/index.ts")))));
	},
	"./elc-vto-foundation-overlay-v1": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/vto-foundation-overlay/index.ts")))));
	},
	"./elc-vto-foundation-qr-code-overlay-v1": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/vto-foundation-qr-code-overlay/index.ts")))));
	},
	"./elc-video-tout-v1": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/video-tout/index.ts")))));
	},
	"./elc-video-tout-youtube-v1": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/video-tout-youtube/index.ts")))));
	},
	"./elc-third-party-tout-v1": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/third-party-tout/index.ts")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});